<template>
    <AutoLettura />
</template>

<script>
  import AutoLettura from '@/components/ask/pages/AutoLettura.vue'

  export default {
    name: 'PageAutoLettura',

    components:{
      AutoLettura
    },
  
    data(){
      return {
      
      }
    },

    created(){
      
    },

    mounted(){
    //   this.$eventBus.emit('page-change', {
    //     target: this,
    //     currentRoute: this.$router.currentRoute.value
    //   })
    },

    methods:{

    },
  }
</script>

<style>

</style>
